module.exports = __webpack_public_path__ + "static/media/iconPostGray.ab05e00a.svg";